// extracted by mini-css-extract-plugin
export var chevron = "_i8-2";
export var dropdownItems = "_i8-0";
export var item = "_i8-1";